export enum tabsIds {
  OVERVIEW,
  EMPLOYEES,
  CONTACT_INFO,
}

const tabsList = {
  OVERVIEW: { id: tabsIds.OVERVIEW, label: 'Overview' },
  EMPLOYEES: { id: tabsIds.EMPLOYEES, label: 'Employees' },
  CONTACT_INFO: { id: tabsIds.CONTACT_INFO, label: 'Contact Info' },
}

export const getTabsList = () => [tabsList.OVERVIEW, tabsList.EMPLOYEES, tabsList.CONTACT_INFO]
